var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getJobDetail != null)?_c('div',[_c('div',{staticClass:"static-element-header"},[_vm._v("Job Description")]),_c('div',{staticClass:"static-element"},[_vm._v(_vm._s(_vm.getJobDetail))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }